export type TModuleOptions = {
  id:number;
  key: string;
  type:string;
  company_id:number;
  legal_code?:string;
  module_id:number | null;
  string_value:string;
  numeric_value:number;
  show:boolean;
}
export type TElementModuleOptions = {
  id:number,
  is_active:boolean,
  sub_type:string,
  element_id:number,
  option_id:number,
  category:string
}

export type TOhterValues = {
  id:number,
  element_id:number,
  field_name:string,
  field_value:string,
  field_type:string,
  is_visible:boolean,
  display_order:number,
}

export type TInventoryFirestore = {
  id:number,
  quantity:number,
  reserved:number,
  uid:string
}
export type TElementPrices = {
  created_at: string;
  description: string | null;
  element_id: number;
  id: number;
  is_active: boolean;
  is_default: boolean;
  is_visible: boolean;
  type: string;
  updated_at: string;
  value: number;
}
export type TPayment = {
  id: number,
  document_id: number,
  payment_method: string,
  payment_method_code: string,
  amount: number,
  reference: string,
  created_at: string
}

export type TStorageElementImage = {
  id?: number
  uid?: string
  element_id?: number
  file_name: string
  file_url: string
  storage_path?: string
  is_primary: boolean
  display_order: number
  created_at?: string
  rawFile?: File
}

export type TStorageItemServer = {
  id:number,
  company_id:number,
  custom_id:string | undefined,
  barcode:string | undefined,
  description:string,
  name:string,
  purchase_item:boolean,
  sell_item:boolean,
  sku:string | undefined,
  location:string | undefined,
  is_active:boolean,
  image_mini:string | undefined,
  image:string | undefined,
  images?: TStorageElementImage[],
  uid:string,
  company_uid:string,
  attributes: any,
  created_at:string,
  updated_at:string
}
export type TStorageItemRS = TStorageItemServer & {
  inventory:TInventoryFirestore[],
  display:string,
  sell_price:number,
  purchase_price:number,
  quantity:number,
  register_type:string,
  measure_unit:string,
  sell_discount:number,
  purchase_discount:number,
  min_quantity?: number,
  is_traceable?: boolean,
  category:string,
  module_options: Partial<TElementModuleOptions>[]
  prices: Partial<TElementPrices>[]
  other_values: Partial<TOhterValues>[]
}
export type TTaxResume = {
  id: number,
  key:string,
  description:string,
  tax_amount:number
}
export type IMovementItemForm = {
  quantity_available:number
  display:string
  unit_price:number
  quantity:number
  name:string
  total_amount:number
  total_amount_full:number
  total_amount_net:number
  discount_amount:number
  discount_rate:number
}
export type IMovementElementItem = IMovementItemForm & {
  document_id:number
  id:number
  uid:string
  key:string
  item_name:string
  item_code:string
  item_description:string
  register_type:string
  total_tax_amount:number
  taxes_list:TTaxResume[]
  inventory:TInventoryFirestore[]
  module_options:Partial<TElementModuleOptions>[]
  register:number
  custom_id:string
}
export interface IMovement {
  approved_by_user_id:number
  created_by_user_id: number
  delivered_by_user_id: number
  received_by_user_id:number
  contact_id?:number
  company_id:number
  document_number:string
  notes: string
  id:number
  document_type:  'PURCHASE_REQUEST' | 'PURCHASE_ORDER' | 'PURCHASE_RECEIPT' | 'SALE_INVOICE' | 'TRANSFER' | 'ADJUSTMENT' | 'RETURN_IN' | 'RETURN_OUT' | 'INITIAL_INVENTORY' | 'PARTNER_CONTRIBUTION' | 'PRODUCTION_ENTRY' | 'PRODUCTION_EXIT' | 'QUOTATION' | 'WASTE'
  status: 'DRAFT' | 'PENDING' | 'APPROVED' | 'COMPLETED' | 'CANCELLED' | 'REJECTED' | 'EXPIRED'
  payment_term: 'CASH' | 'CREDIT'
  credit_days:number
  invoice_type: 'ELECTRONIC_INVOICE' | 'SIMPLE_RECEIPT' | 'POS_RECEIPT' | 'CREDIT_NOTE' | 'DEBIT_NOTE'
  credit_due_date:string
  reference_document:string
  total_amount:number
  total_discount_amount:number
  total_tax_amount:number
  cash_return_amount: number,
  storehouse_from_id: number,
  storehouse_to_id: number,
  updated_at:string
  created_at: string
  uid:string
}
export type IMovementRS = IMovement & {
  approved_by_user_name?:string
  approved_by_user_document?:string
  created_by_user_name?:string
  created_by_user_document?:string
  delivered_by_user_name?:string
  delivered_by_user_document?:string
  received_by_user_name?:string
  received_by_user_document?:string
  total_amount_net: number,
  total_amount_full: number,
  contact_name:string
  contact_document?:string
  item_list: IMovementElementItem[],
  payments: TPayment[],
  taxes_list:TTaxResume[],
  items:number
  type:string
}
export const defaultStorageItemValues:TStorageItemRS = {
  id: 0,
  company_id: 0,
  custom_id: "",
  barcode: "",
  description: "",
  name: "",
  purchase_item: false,
  sell_item: false,
  sku: "",
  location: "",
  is_active: false,
  image_mini: "",
  image: "",
  uid: "",
  inventory:[],
  display:"",
  sell_price:0,
  purchase_price:0,
  quantity:0,
  company_uid: "",
  attributes: {},
  created_at: "",
  updated_at: "",
  register_type:"",
  measure_unit:"",
  category:"",
  sell_discount:0,
  purchase_discount:0,
  module_options: [],
  prices: [],
  other_values: []
}